<template>
  <!--招聘活动  -->
  <div class="container">
    <div class="content">
      <div class="title-box">
        <div class="des">
          <div class="title">
            {{ title }}
          </div>
          <div>发布日期：{{ date }}</div>
        </div>
        <div class="btn" v-show="type == 1">
          <el-button @click="toPostList" type="primary">查看岗位信息</el-button>
        </div>
        <div class="btn" v-show="type == 2">
          <el-button type="primary" @click="showDialog('application')"
            >立即报名</el-button
          >
          <applicationNow ref="application"></applicationNow>
        </div>
      </div>
      <div>
        <p v-html="content"></p>
      </div>
      <div style="margin-top: 30px">
        <div
          v-for="item in fjxx"
          :key="item.fjxxid"
          class="link line"
          @click="downloadFj(item)"
        >
          {{ item.fjmc }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/api/recruitmentActivity";
import applicationNow from "../postList/components/applicationNow.vue";
export default {
  props: ["id", "type", "title", "date", "zplb"],
  components: {
    applicationNow,
  },
  data() {
    return {
      content: "",
      fjxx: [], //附件信息
    };
  },
  created() {
    this.getInfo();
  },
  computed: {
    /* 登录状态，刷新后从缓存取值 */
    isLogin() {
      return this.$store.getters.isLogin;
    },
  },
  methods: {
    /**
     * 下载附件信息
     */
    async downloadFj(data) {
      let para = {
        fjxxid: data.fjxxid,
      };
      let result = await request.downloadFj(para);
      // const fileName = `${this.form.dyxlbyxx}-${this.form.dyxlzy}-${this.form.xm}.zip`
      /* 兼容ie内核，360浏览器的兼容模式 */
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // const blob = new Blob([data], { type: 'application/zip' })
        const blob = new Blob([result]);
        window.navigator.msSaveOrOpenBlob(blob, "");
      } else {
        /* 火狐谷歌的文件下载方式 */
        // const blob = new Blob([data], { type: 'application/zip' })
        const blob = new Blob([result]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a"); // 创建a标签
        link.href = url;
        link.download = data.fjmc; // 文件重命名，若无需重命名，将该行删去
        link.click();
        URL.revokeObjectURL(url); // 释放内存
      }
    },
    async getInfo() {
      const para = {
        zphdlx: this.type,
        zphdid: this.id,
      };
      const data = await request.getDetail(para);
      console.log("data", data);
      this.content = data.ds[0].nr;
      this.fjxx = data.dsfjxx;
    },
    /* 查看岗位信息 */
    toPostList() {
      this.$router.push({
        path: "/postList",
        query: {
          id: this.id,
          title: this.title,
          zphdlx: this.type,
          zplb: this.zplb,
        },
      });
    },
    showDialog(refName) {
      if (this.isLogin) {
        let para = {
          zphdlx: this.type,
          zphdmc: this.title,
          zphdid: this.id,
          zplb: this.zplb,
        };
        this.$refs[refName].show(para);
      } else {
        this.$store.commit("openLogin");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  .link {
    color: dodgerblue;
    &:hover {
      cursor: pointer;
    }
  }
  .line {
    margin: 15px 0;
  }
  background: #f7f9fa;
  .content {
    width: 70%;
    margin: 20px auto;
    padding: 20px;
    background: #fff;
    .title-box {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      padding-bottom: 20px;
      align-items: center;
      border-bottom: 1px solid #d9d9d9;
      margin-bottom: 20px;
    }
    .btn {
      width: 15%;
    }
    .des {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 85%;
      .title {
        font-size: 18px;
        font-weight: 700;
        color: #333;
        padding-bottom: 20px;
      }
      .date {
        font-size: 14px;
        color: #000;
      }
    }
  }
}
::v-deep table {
  border-collapse: collapse !important;
}
::v-deep  td,th {
  border: 1px solid #ccc !important;
  padding: 5px;
}
::v-deep  th {
  border: 1px solid #ccc !important;
  background-color: #f1f1f1 !important;
  padding: 5px;
}
</style>
